import { render } from "./Story.vue?vue&type=template&id=04cb04c4&scoped=true"
import script from "./Story.vue?vue&type=script&lang=js"
export * from "./Story.vue?vue&type=script&lang=js"

import "./Story.vue?vue&type=style&index=0&id=04cb04c4&scoped=true&lang=css"

import exportComponent from "D:\\Development\\VSTS.Git\\FleuristeBergeron\\Spec_2.0\\Solutions\\WWW\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cb04c4"]])

export default __exports__